var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgInsightFilled = function SvgInsightFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h26.073v26.074H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M0 0h16.464v16.464H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m23.078 13.53 2.995-.493-2.995-.494a11.578 11.578 0 0 1-9.547-9.548L13.036 0l-.492 2.995a11.58 11.58 0 0 1-9.549 9.548L0 13.037l2.996.493a11.58 11.58 0 0 1 9.549 9.548l.492 2.996.495-2.996a11.58 11.58 0 0 1 9.547-9.548",
    fill: "#231F20",
    mask: "url(#b)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(16.841 16.765)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#c"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.469 7.739a5.75 5.75 0 0 1-4.743-4.743L8.232 0l-.493 2.996a5.75 5.75 0 0 1-4.743 4.743L0 8.232l2.996.494a5.75 5.75 0 0 1 4.743 4.743l.493 2.995.494-2.995a5.75 5.75 0 0 1 4.743-4.743l2.995-.494-2.995-.493z",
    fill: "#231F20",
    mask: "url(#d)"
  })))));
};
export { SvgInsightFilled as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzYiIGhlaWdodD0iMzYiIHZpZXdCb3g9IjAgMCAzNiAzNiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cGF0aCBpZD0iYSIgZD0iTTAgMGgyNi4wNzN2MjYuMDc0SDB6Ii8+CiAgICAgICAgPHBhdGggaWQ9ImMiIGQ9Ik0wIDBoMTYuNDY0djE2LjQ2NEgweiIvPgogICAgPC9kZWZzPgogICAgPGcgZmlsbD0ibm9uZSIgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgICAgICA8ZyB0cmFuc2Zvcm09InRyYW5zbGF0ZSgyIDIpIj4KICAgICAgICAgICAgPG1hc2sgaWQ9ImIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYSIvPgogICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgIDxwYXRoIGQ9Im0yMy4wNzggMTMuNTMgMi45OTUtLjQ5My0yLjk5NS0uNDk0YTExLjU3OCAxMS41NzggMCAwIDEtOS41NDctOS41NDhMMTMuMDM2IDBsLS40OTIgMi45OTVhMTEuNTggMTEuNTggMCAwIDEtOS41NDkgOS41NDhMMCAxMy4wMzdsMi45OTYuNDkzYTExLjU4IDExLjU4IDAgMCAxIDkuNTQ5IDkuNTQ4bC40OTIgMi45OTYuNDk1LTIuOTk2YTExLjU4IDExLjU4IDAgMCAxIDkuNTQ3LTkuNTQ4IiBmaWxsPSIjMjMxRjIwIiBtYXNrPSJ1cmwoI2IpIi8+CiAgICAgICAgPC9nPgogICAgICAgIDxnIHRyYW5zZm9ybT0idHJhbnNsYXRlKDE2Ljg0MSAxNi43NjUpIj4KICAgICAgICAgICAgPG1hc2sgaWQ9ImQiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICAgICAgPHVzZSB4bGluazpocmVmPSIjYyIvPgogICAgICAgICAgICA8L21hc2s+CiAgICAgICAgICAgIDxwYXRoIGQ9Ik0xMy40NjkgNy43MzlhNS43NSA1Ljc1IDAgMCAxLTQuNzQzLTQuNzQzTDguMjMyIDBsLS40OTMgMi45OTZhNS43NSA1Ljc1IDAgMCAxLTQuNzQzIDQuNzQzTDAgOC4yMzJsMi45OTYuNDk0YTUuNzUgNS43NSAwIDAgMSA0Ljc0MyA0Ljc0M2wuNDkzIDIuOTk1LjQ5NC0yLjk5NWE1Ljc1IDUuNzUgMCAwIDEgNC43NDMtNC43NDNsMi45OTUtLjQ5NC0yLjk5NS0uNDkzeiIgZmlsbD0iIzIzMUYyMCIgbWFzaz0idXJsKCNkKSIvPgogICAgICAgIDwvZz4KICAgIDwvZz4KPC9zdmc+Cg==";